// extracted by mini-css-extract-plugin
module.exports = {"FaqListArea":"FaqBoard_FaqListArea__zwA84","MoreBtnArea":"FaqBoard_MoreBtnArea__CS7E_"};